<template>
  <div class="usc-section-nav">
    <router-link v-ripple :class="[nextRoute === undefined ? 'usc-section-nav--fullwidth' : '']" class="usc-section-nav--button usc-section-nav--prev" v-if="prevRoute"
      :to="{name: prevRoute.route}">
      <div class="usc-section-nav--arrow" aria-hidden="true">
        <img src="../assets/large_arrow.svg" alt="Large arrow pointing left">
      </div>
      <div class="usc-section-nav--text">
        <span class="usc-section-nav--direction">Prev</span>
        <span :class="['usc-section-nav--title', prevRoute.classSuffix]">{{prevRoute.title}}</span>
      </div>
    </router-link>

    <!-- <div class="usc-section-nav--divider" v-if="prevRoute && nextRoute">
      <div class="usc-section-nav--divider--internal"></div>
    </div> -->

    <router-link v-ripple :class="[prevRoute === undefined ? 'usc-section-nav--fullwidth' : '']" class="usc-section-nav--button usc-section-nav--next" v-if="nextRoute"
      :to="{name: nextRoute.route}">
      <div class="usc-section-nav--text">
        <span class="usc-section-nav--direction">Next</span>
        <span :class="['usc-section-nav--title', nextRoute.classSuffix]">{{nextRoute.title}}</span>
      </div>
      <div class="usc-section-nav--arrow" aria-hidden="true">
        <img src="../assets/large_arrow.svg" alt="Large arrow pointing right">
      </div>
    </router-link>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'usc-section-nav',
  data () {
    return {
      prevRoute: null,
      nextRoute: null
    }
  },
  watch: {
    '$route' (to, from) {
      this.updateRoute(to)
    }
  },
  methods: {
    updateRoute (to) {
      // Find our route in the sidenav route list
      const routes = _(this.$root.sidenav).chain()
        .map(n => n.items || n) // Account for nav items that have no children
        .flatten()
        .pull(undefined)
        .value()

      const currentRouteIdx = _(routes).findIndex(r => r.route === to.name)
      this.prevRoute = currentRouteIdx >= 0 ? routes[currentRouteIdx - 1] : null
      this.nextRoute = currentRouteIdx < routes.length ? routes[currentRouteIdx + 1] : null

      this.findRouteParent(routes[currentRouteIdx])
    },
    findRouteParent (route) {
      // Only works if the nav tree is never more than 2 deep
      /*
      debugger
      for (let i = 0; i < this.$root.sidenav.length; i++) {
        if (this.$root.sidenav[i].indexOf(route)) {
          return this.$root.sidenav[i]
        }
        if (this.$root.sidenav[i].items) {
          for(let j = 0; j < this.$root.sidenav[i].items.length; j++) {
            if (this.$root.sidenav[i].items[j].indexOf(route)) {
              return this.$root.sidenav[i].items[j]
            }
          }
        }
      }
      */
      return undefined

      // Why is this so hard? :(
      /*
      if(root.items) {
        for(const i = 0; i < root.items.length; i++) {
          return findRouteParent(root.items[i], route);
        }
      }
      */
      /*
      debugger
      let parent = undefined
      if(root.indexOf(route) >= 0) {
        parent = root
      } else if(root.items) {
        for (let i = 0; i < root.items && !parent; i++) {
          if(root.items[i].items) {
            parent = this.findRouteParent(root.items[i], route)
          }
        }
      }
      return parent
      */
      /*
      if (root.items && root.items.indexOf(route)) {
        return root
      } else if (root.items) {
        for (let i = 0; i < root.items.length; i++) {
          return this.findRouteParent(root.items[i], route)
        }
      }
      return undefined
      */
    }
  },
  mounted () {
    this.updateRoute(this.$route)
  }
}
</script>

<style lang="scss">
@import '~styles/vars';
@import '~styles/mixins';

.usc-section-nav {
  display: flex;
  flex-direction: column-reverse;

  @media(min-width: $screen-sm-min) {
    flex-direction: row;
  }

  &--prev {
    border-top: 1px solid #ededed;
    @media(min-width: $screen-sm-min) {
      border-top: none;
      border-right: 1px solid #ededed;
    }
  }
  > .usc-section-nav--divider {
    display: none;
    @media(min-width: $screen-sm-min) {
      display: flex;
      flex: 1;
      background: #fff;
      align-items: center;
      justify-content: center;
    }
    > .usc-section-nav--divider--internal {
      width: 1px;
      background: #ededed;
      height: 100%;
    }
  }

  > .usc-section-nav--button {
    // flex: 1; this caused ie11 to not stack buttons on mobile
    display: flex;
    flex-direction: row;
    text-decoration: none;
    color: inherit;
    background-color: #FFF;
    padding-top: 25px;
    padding-bottom: 25px;
    width: 100%;
    @media(min-width: $screen-sm-min) {
      width: 50%;
      &.usc-section-nav--fullwidth {
        width: 100%;
      }
    }
    &:hover {
      > .usc-section-nav--arrow {
        opacity: .5;
      }
    }

    &.usc-section-nav--prev .usc-section-nav--arrow > img{
      transform: rotate(180deg);
    }
    &.usc-section-nav--next {
      justify-content: flex-end;
      .usc-section-nav--text {
        text-align: right;
      }
    }

    .usc-section-nav--text {
      font-family: $fNational;
      span {
        display: block;
      }
      .usc-section-nav--direction {
        font-size: px2rem(24);
        font-weight: $fLight;
      }
      .usc-section-nav--title {
        font-size: px2rem(15);
        font-weight: $fRegular;

        &.intro { color: #000; }
        &.academics { color: #000; }
        &.opportunities { color: #000; }
        &.life { color: #000; }
        &.next_steps { color: #000; }
        &.resources { color: #000; }
      }
    }
    .usc-section-nav--arrow {
      display: flex;
      justify-content: center;
      color: #000;
      opacity: .7;
      transition: .2s opacity;
      align-items: center;
      padding: 0 20px;
      > img {
        width: 12px;
        height: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionNav.vue